import createLucideIcon from '../createLucideIcon';

const SearchSlash = createLucideIcon('SearchSlash', [
  ['path', { d: 'm13.5 8.5-5 5', key: '1cs55j' }],
  ['circle', { cx: '11', cy: '11', r: '8', key: '4ej97u' }],
  ['path', { d: 'm21 21-4.3-4.3', key: '1qie3q' }],
]);

export default SearchSlash;
